import Phaser from "phaser";

import BootScene from "../scenes/BootScene";
import GameScene from "../scenes/GameScene";
import UIScene from "../scenes/UIScene";

// フォントを確実に読み込む関数
async function ensureFont(family: string, url: string): Promise<boolean> {
  try {
    // 既に読み込まれているか確認
    if (document.fonts.check(`16px "${family}"`)) {
      console.log(`[Font] ${family} already loaded`);
      return true;
    }

    const ff = new FontFace(family, `url(${url})`);
    await ff.load();
    document.fonts.add(ff);

    // これを待つと Canvas 側でも使える状態になりやすい
    await document.fonts.load(`16px "${family}"`);

    const ok = document.fonts.check(`16px "${family}"`);
    console.log(`[Font] ${family} ready:`, ok, "url:", url);
    return ok;
  } catch (e) {
    console.error(`[Font] ${family} load failed. url: ${url}`, e);
    return false;
  }
}

export async function createGame(parentId: string): Promise<Phaser.Game> {
  // フォントを先に読み込む
  const [kirangOk, pottaOk] = await Promise.all([
    ensureFont("KirangHaerang", "./fonts/KirangHaerang-Regular.ttf"),
    ensureFont("PottaOne", "./fonts/PottaOne-Regular.ttf"),
  ]);

  console.log("[createGame] fonts ready:", { kirangOk, pottaOk });

  // フォントが読み込まれた後にPhaser Gameを作成
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent: parentId,
    backgroundColor: "#0b0b0b",
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 720,
      height: 1280,
    },
    physics: { default: "arcade" },
    scene: [BootScene, GameScene, UIScene],
  });
}


